<script>
	import { page } from "$app/stores";

	import { theme as themeStore } from "$lib/utilities/theme";
	import { getActionObject } from "$lib/utilities/getActionObject";

	import Action from "../components/Action.svelte";

	export let data;
	export let preview = false;
	export let theme;

	let lang;
	$: lang = $page.data.lang;

	let area;
	$: area = $page.data.area;

	$: useTheme = theme || $themeStore;

	$: action = getActionObject(
		data,
		lang,
		area,
		"settings",
		"Header",
		useTheme,
		"banner",
	);
</script>

<Action {data} {preview} {action} />
